import React from "react";
import { useState } from "react";

const SignupRight: React.FC = () => {
    const [names, setNames] = useState("");
    const handleSignup = (event: any) => {
        event.preventDefault();
        alert(`Your names are: ${names}`);
        console.log("Sign Up form SUbmitted");
        
    }
    return (
        <div className="flex flex-col lg:h-full h-fit lg:w-[55%] w-full justify-between bg-white py-12 text-lg">
            <div className="mb-6">
                <div className="mb-6 leading-6 w-[85%] mx-auto">
                    <h1>Sign up to <span className="text-[#DFA321]">Murwiza</span> </h1>
                    <span className="text-[#D9D9D9]">Create your account</span>
                </div>
                <div className="flex flex-col leading-9 w-full items-center">
                    <input className="outline-none p-3 bg-[#F7F7F7] mb-6 w-[85%] rounded-md pl-4" type="text" placeholder="Full Names" value={names} onChange={(e) => setNames(e.target.value)} required />
                    <input className="outline-none p-3 bg-[#F7F7F7] mb-6 w-[85%] rounded-md pl-4" type="email" placeholder="Email address" required />
                    <input className="outline-none p-3 bg-[#F7F7F7] mb-6 w-[85%] rounded-md pl-4" type="password" placeholder="Password" required />
                    <input className="outline-none p-3 bg-[#F7F7F7] w-[85%] rounded-md pl-4" type="password" placeholder="Confirm Password" required />
                    <div className="flex mt-2 mb-4">
                        <input type="checkbox" className="mr-4" />
                        <div>
                            <span className="text-[#D9D9D9]">I accept the <span className="text-[#5182FF]"><a href="#terms">terms and conditions</a> </span> <br className="md:hidden" /> and <span className="text-[#5182FF]"><a href="#agreements">user agreements</a> </span></span>
                        </div>
                    </div>
                    <button className="w-[85%] bg-[#5182FF] p-2 mb-5 pl-4 text-white" onClick={handleSignup}>Signup</button>
                </div>
            </div>
            <div className="mb-6 leading-6 w-[85%] text-center">
                <span className="mr-4">Already have an account? </span>
                <span className="text-[#5182FF]"><a href="#login">Login instead</a> </span>
            </div>
        </div>
    )
}
export default SignupRight;